import React from "react";
import { Button } from "../../../ui/button";
import { useNavigate } from "react-router-dom";
import AudioPlayer from "./Audioplayer-error";
import Image from "../../../Tags/Image";
import { useTheme } from "../../../ThemeProvider";

export default function RecordingOnlyView({ recordingUrl, callMetadata }) {
  const navigate = useNavigate();
  const { theme } = useTheme();
  console.log("callMetadata for 404", callMetadata);
  console.log("recordingUrl for 404", recordingUrl);
  return (
    <div className=" mx-auto mt-6">
      <div>
        {/* Audio Player */}
        <AudioPlayer
          audioUrl={recordingUrl}
          callMetadata={callMetadata}
        />
        {/* No Analysis Available Message */}
        <div className="text-center py-12">
          <div className="illustration mb-6">
            <div className="flex justify-center">
              <div className="relative">
                <div className="flex items-center justify-center">
                  {theme === "dark" ? (
                    <Image 
                      src="/images/icons/untitledui/call-logs/listening-music-dark.png"
                      alt="No analysis available"
                      width={240}
                      height={240}
                      className="no-invert"
                    />
                  ) : (
                    <Image 
                      src="/images/icons/untitledui/call-logs/listening-music.svg"
                      alt="No analysis available"
                      width={240}
                      height={240}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <h3 className="text-lg font-medium text-[#414651] dark:text-white mb-2">
            The recording is too short for us to provide any insights!
          </h3>
        </div>
      </div>
    </div>
  );
} 